import { useState } from 'react'

import { IPktStep, TStepStatus } from '@/components/stepper/Step'

import { PktButton,PktStep, PktStepper } from '..'

export default function Stepper() {
  const [activeStep, setActiveStep] = useState(0)

  const stepContent = (
    <div>
      Beskrivelse av steget
      <div className="pkt-step__nav-wrapper">
        {activeStep >= 1 && <PktButton onClick={() => setActiveStep(activeStep - 1)}>Back</PktButton>}
        <PktButton onClick={() => setActiveStep(activeStep + 1)}>Next</PktButton>
      </div>
    </div>
  )
  const steps: Omit<IPktStep, 'status'>[] = [
    {
      title: 'Step 1',
      children: <>{stepContent}</>,
    },
    { title: 'Step 2', children: <>{stepContent}</> },
    { title: 'Step 3', children: <>{stepContent}</> },
    { title: 'Step 4', children: <>{stepContent}</> },
    { title: 'Step 5', children: <>{stepContent}</> },
  ]

  const getStepStatus = (index: number, activeStep: number): TStepStatus => {
    if (index < activeStep) {
      return 'completed'
    }
    if (index === activeStep) {
      return 'current'
    }
    return 'incomplete'
  }

  return (
    <>
      <main className="page-main pkt-container">
        <h1>Stepper</h1>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gridTemplateRows: 'auto',
            rowGap: '1rem',
            background: 'white',
          }}
        >
          <section className="component">
            <h2>Orientation: Vertical (default)</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveStepsContent: true (default)</li>
            </ul>
            <PktStepper activeStep={activeStep} hideNonActiveStepsContent={true}>
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>

          <section className="component">
            <h2>Orientation: Vertical (default)</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveStepsContent: false</li>
            </ul>
            <PktStepper activeStep={activeStep} hideNonActiveStepsContent={false}>
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>

          <section className="component">
            <h2>Orientation: Horizontal</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveStepsContent: true (default)</li>
            </ul>
            <PktStepper activeStep={activeStep} hideNonActiveStepsContent={true} orientation="horizontal">
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>

          <section className="component">
            <h2>Orientation: Horizontal</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveStepsContent: false</li>
            </ul>
            <PktStepper activeStep={activeStep} hideNonActiveStepsContent={false} orientation="horizontal">
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>

          <section className="component">
            <h2>Orientation: Vertical (default)</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveSteps: true</li>
              <li>mindre spacing mellom stegene</li>
            </ul>
            <p>hideNonActiveSteps = gjem både tittel og beskrivelse på ikke-aktivt steg</p>

            <PktStepper activeStep={activeStep} hideNonActiveSteps={true}>
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>
          <section className="component">
            <h2>Orientation: Horizontal</h2>
            <ul style={{ fontWeight: 'bold' }}>
              <li>hideNonActiveSteps: true</li>
              <li>mindre spacing mellom stegene</li>
            </ul>
            <p>hideNonActiveSteps = gjem både tittel og beskrivelse på ikke-aktivt steg</p>

            <PktStepper activeStep={activeStep} hideNonActiveSteps={true} orientation="horizontal">
              {steps.map((step, index) => (
                <PktStep key={index} title={step.title} status={getStepStatus(index, activeStep)}>
                  {step.children}
                </PktStep>
              ))}
            </PktStepper>
          </section>
        </div>
      </main>
    </>
  )
}
